import { Component, Input } from '@angular/core';
import { UntypedFormArray, UntypedFormGroup, AbstractControl, UntypedFormControl } from '@angular/forms';

import { CreateFormPhone } from 'src/app/shared/components/phone/shared/build';
import { NativeFocus } from 'src/app/shared/utils';

@Component({
  selector: 'app-phone',
  templateUrl: './phone.component.html',
  styleUrls: ['./phone.component.scss']
})
export class PhoneComponent {

  public phones: UntypedFormArray;
  public phoneList: AbstractControl[];

  @Input() set formulario(form: UntypedFormGroup) {
    this.setPhone(<UntypedFormArray>form.get('phones'));
  }

  private setPhone(phones: UntypedFormArray): void {
    this.phones = phones;
    this.phoneList = phones.controls.filter(control => !control.get('deleted').value);
  }

  public newPhone(_event): void {
    const form = CreateFormPhone(null);
    this.phones.push(form);
    this.setPhone(this.phones);

    NativeFocus(form.get('number'));
  }

  public setPrimary(event: Event, control: UntypedFormControl): void {
    const newValue = !control.get('primary').value;
    this.phoneList.forEach(item => item.patchValue({ primary: false }));

    if (newValue) {
      control.patchValue({ primary: newValue });
    }
  }

  public toggle(event: Event, control: UntypedFormControl, name: string): void {
    control.patchValue({ [name]: !control.get(name).value });
  }

  public removePhone(event: Event, control: AbstractControl): void {
    const index = this.phones.controls.indexOf(control);
    control.patchValue({ deleted: true });

    const controlID = control.get('id');
    if (!controlID || !controlID.value) {
      this.phones.removeAt(index);
    }

    this.setPhone(this.phones);
  }
}
